import getTenantFromPath from "@irati/identity/helpers/getTenantFromPath"
import env from "@irati/utils/env"
import {PRODUCTION} from "@irati/utils/constants/environment"

class DomainHelpers {
  isInternal(): boolean {
    return getTenantFromPath() === "admin" || window?.location?.hostname === "localhost"
  }
  isDev(): boolean {
    return getTenantFromPath() === "dev" && env.ENVIRONMENT_NAME !== PRODUCTION
  }
  isMerchant(): boolean {
    return getTenantFromPath() === "merchant"
  }
  isGlobal(): boolean {
    return !getTenantFromPath() && window?.location?.hostname !== "localhost"
  }
  isTenant(): boolean {
    return !(this.isInternal() || this.isDev() || this.isMerchant() || this.isGlobal())
  }
}

export default new DomainHelpers()
